module.exports = "/_next/static/images/6048031c35519c1feba8d769b245149c-Nubank_HickDuarte_59058 1_xs.png.webp";